module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_with_news_with_quests.bc7d4336.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_with_news_with_quests.jpg
// module id = 3036
// module chunks = 11